import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { BehaviorSubject, combineLatest, EMPTY, Observable, of, Subject } from 'rxjs';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { Document, DocumentViewerDocument } from '../../../../../../_shared/model';
import { BaseState } from '../../../../../../_shared/state/base/base.state';
import { ExaminationState } from '../../../../../../_shared/state/examinations/examinations-state';
import { TermsService } from '../../../_services';
import { DocumentsService } from '../../../_services/documents.service';
import { DocumentReloadModel } from './model/document-reload-model';

@Injectable({
    providedIn: null,
})
export class TermCommunicationsService {
    constructor(
        private docviewRest: DocumentsService,
        private store: Store,
        private termsService: TermsService,
    ) {}
    public validateForm: Subject<void> = new Subject();
    public reloadData: Subject<void> = new Subject();
    public reloadDocumentsSubject = new BehaviorSubject<DocumentReloadModel>(null);
    public onDestroy$ = new Subject<void>();

    public createDocumentList$(): Observable<DocumentViewerDocument[]> {
        return this.reloadDocumentsSubject.pipe(
            takeUntil(this.onDestroy$),
            switchMap(reloadModel => {
                if (reloadModel) {
                    return combineLatest([
                        this.docviewRest.getDocumentsVR(reloadModel?.preReservationId, Number(reloadModel?.visitId)).pipe(catchError(() => of([]))),
                        this.termsService
                            .getReservationMedicalRecord(reloadModel?.preReservationId, this.store.selectSnapshot(BaseState.activeContractorId))
                            .pipe(
                                catchError(() => {
                                    return of(null);
                                }),
                                map(res => {
                                    if (!res || !res.documents?.documents?.length) {
                                        return [];
                                    }
                                    return res.documents.documents.map(
                                        doc =>
                                            ({
                                                ...doc,
                                                isMedicalRecordDocument: true,
                                            }) as Document,
                                    );
                                }),
                            ),
                    ]);
                }
                return of([]);
            }),
            map(([docs, medicalRecordDocs]) => [docs, medicalRecordDocs].flat().filter(doc => doc)),
            switchMap(res => {
                return combineLatest([of(res), this.store.select(ExaminationState.documentViewerDocuments$)]).pipe(
                    map(([res, examDocs]) =>
                        (res ?? []).concat(
                            (examDocs ?? []).map(doc => {
                                return { ...doc, isReadOnly: true } as DocumentViewerDocument;
                            }),
                        ),
                    ),
                );
            }),
            map(docs => {
                if (!_.isNil(docs)) {
                    return docs.map(el => new DocumentViewerDocument().deserialize(el));
                }
                return [];
            }),
            catchError(() => {
                return EMPTY;
            }),
        );
    }
}
